<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-30">
            Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>
            <div class="content-title padding-5 margin-top-10">
                <div class="roadmap-back-wrapper ipad-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/> <span class="">Back to Success Road Map</span>
                    </router-link>
                </div>
                <div class="roadmap-back-wrapper mobile-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0 ">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-title-wrapper">
                    Existing Leader
                    <br>Development Journey
                </div>
                <div class="clear"></div>
            </div>
            <div class="boss-content">
                <p class="boss-content-text1"><b>Agency System & Recruitment Development</b></p>
                <p><b style="color: red">ROAR</b><b style="color: black;"> with Recruitment</b></p>
                <b class="boss-content-text2">(<b style="color: red">R</b>ecruit, <b style="color: red">O</b>nboarding, <b style="color: red">A</b>ctivation, <b style="color: red">R</b>einforcement)</b>
            </div>
            <!-- mobile -->
            <div class="mobile-display">
                <div>
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_1.png'" class="responsive-image" style="max-width: 385px !important"/>
                </div>
                <div>
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_2.png'" class="responsive-image" style="max-width: 385px !important"/>
                </div>
                <div>
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_3.png'" class="responsive-image" style="max-width: 385px !important"/>
                </div>
                <div class="margin-bottom-10">
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_4.png'" class="responsive-image" style="max-width: 385px !important"/>
                </div>
                <!-- <p class="mandatory">*Mandatory Program</p> -->
            </div>

            <!-- ipad -->
            <div class="ipad-display center-width">
                <div class="col-2">
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_1.png'" class="responsive-image" />
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_3.png'" class="responsive-image" />
                </div>
                <div class="col-2 margin-bottom-10">
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_2.png'" class="responsive-image" />
                    <img :src="'images/mpower/roadmap/2022/Existing-Leader_4.png'" class="responsive-image" />
                </div>
                <div class="clear"></div>
                <!-- <p class="mandatory">*Mandatory Program</p> -->
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory{
    text-align: left;
    padding-left: 10px;
    color:#6b867f;
}
.ipad-display .mandatory{
    text-align: right;
    padding-right: 20px;
    color:#6b867f;
}
.center-width{
    max-width: 800px;
    margin: 0 auto;
}
.boss-content{
  padding: 10px;
}
.boss-content .boss-content-text1{
  color: #0005D3;
}
.boss-content .boss-content-text2{
  font-style: italic;
  color: black;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Leader_journey',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#2A317B'
            }
        }
    },
    components: {
        RoadmapNav
    },
    mounted(){
        window.scrollTo(0,0);
    }
}
</script>
